import {environment} from '../../../environments/environment';
import {Injectable} from '@angular/core';

@Injectable()
export class AppUrl {
    static get APP_URL(): string {
        return environment.appUrl + 'stockist/';
    }

    static get LOGIN(): string {
        return AppUrl.APP_URL + 'login';
    }

    static get SELF(): string {
        return AppUrl.APP_URL + 'self';
    }

    static UPDATE_SELF(): string {
        return AppUrl.APP_URL + 'update-self';
    }

    static LOGOUT(): string {
        return AppUrl.APP_URL + 'logout';
    }

    static PROFILE_IMAGE(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'my-profile-image/' + id;
        } else {
            return AppUrl.APP_URL + 'my-profile-image';
        }
    }

    static SELF_PROFILE_PASSWORD(): string {
        return AppUrl.APP_URL + 'update-user-password';
    }


    static VERIFY_OTP_SELF_PROFILE_PASSWORD(): string {
        return AppUrl.APP_URL + 'verify-otp-update-user-password';
    }

    static PRODUCT(): string {
        return AppUrl.APP_URL + 'product';
    }

    static PRODUCT_COUNT(): string {
        return AppUrl.APP_URL + 'product-count';
    }

    static SESSION(): string {
        return AppUrl.APP_URL + 'session';
    }

    static ORDER(): string {
        return AppUrl.APP_URL + 'stockist-product-order';
    }

    static ORDER_COUNT(): string {
        return AppUrl.APP_URL + 'stockist-product-order-count';
    }

    static ORDER_DELIVERED_COUNT(): string {
        return AppUrl.APP_URL + 'stockist-delivered-order-count';
    }

    static ORDER_PLACED_COUNT(): string {
        return AppUrl.APP_URL + 'stockist-placed-order-count';
    }

    static ORDER_DELIVERED_STATUS(id): string {
        return AppUrl.APP_URL + 'user-product-order-deliver/' + id;
    }

    static PACKAGE_ORDER_DELIVERED_STATUS(id): string {
        return AppUrl.APP_URL + 'user-package-order-deliver/' + id;
    }

    static ORDER_CANCELLED_STATUS(id): string {
        return AppUrl.APP_URL + 'user-product-order-cancel/' + id;
    }

    static DOWNLOAD_USER_PRODUCT_ORDER_REPORT(): string {
        return AppUrl.APP_URL + 'download-user-product-order-report';
    }

    static DOWNLOAD_USER_PACKAGE_ORDER_REPORT(): string {
        return AppUrl.APP_URL + 'download-user-package-order-report';
    }

    static STOCKIST_ORDER_DISPATCHED_STATUS(id): string {
        return AppUrl.APP_URL + 'stockist-product-order-deliver/' + id;
    }

    static CART(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'cart/' + id;
        } else {
            return AppUrl.APP_URL + 'cart';
        }
    }

    static CLEAR_CART(): string {
        return AppUrl.APP_URL + 'clear-cart';
    }

    static USER_PRODUCT_ORDER(): string {
        return AppUrl.APP_URL + 'user-product-order';
    }

    static USER_PRODUCT_ORDER_COUNT(): string {
        return AppUrl.APP_URL + 'user-product-order-count';
    }

    static USER_PACKAGES_ORDER(): string {
        return AppUrl.APP_URL + 'package-order';
    }

    static USER_PACKAGES_ORDER_COUNT(): string {
        return AppUrl.APP_URL + 'package-order-count';
    }

    static MY_PRODUCT(): string {
        return AppUrl.APP_URL + 'stockist-product';
    }

    static PACKAGE(): string {
        return AppUrl.APP_URL + 'package';
    }

    static PACKAGE_COUNT(): string {
        return AppUrl.APP_URL + 'package-count';
    }

    static STOCKIST(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'stockist/' + id;
        } else {
            return AppUrl.APP_URL + 'stockist';
        }
    }

    static STOCKIST_PAN(): string {
        return AppUrl.APP_URL + 'stockist-pan';
    }

    static STOCKIST_AADHAR(): string {
        return AppUrl.APP_URL + 'stockist-aadhar';
    }

    static STOCKIST_BANK(): string {
        return AppUrl.APP_URL + 'stockist-bank';
    }

    static STOCKIST_NOMINEE(): string {
        return AppUrl.APP_URL + 'stockist-nominee';
    }

    static FILE_UPLOAD(): string {
        return AppUrl.APP_URL + 'file-upload';
    }

    static STATES(): string {
        return AppUrl.APP_URL + 'states';
    }

    static ADDRESS(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'address/' + id;
        } else {
            return AppUrl.APP_URL + 'address';
        }
    }

    static SUPPORT(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'support/' + id;
        } else {
            return AppUrl.APP_URL + 'support';
        }
    }

    static STOCKIST_WITHDRAW_REQUEST(): string {
        return AppUrl.APP_URL + 'withdraw-request';
    }

    static STOCKIST_TRANSACTION(id?): string {
        if (id) {
            return AppUrl.APP_URL + 'stockist-transaction/' + id;
        } else {
            return AppUrl.APP_URL + 'stockist-transaction';
        }
    }

    static DOWNLOAD_STOCKIST_TRANSACTION(): string {
        return AppUrl.APP_URL + 'download-stockist-transaction';
    }
}
